import { render, staticRenderFns } from "./works_audio.vue?vue&type=template&id=71a6f94e&scoped=true&"
import script from "./works_audio.vue?vue&type=script&lang=js&"
export * from "./works_audio.vue?vue&type=script&lang=js&"
import style0 from "./works_audio.vue?vue&type=style&index=0&id=71a6f94e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6f94e",
  null
  
)

export default component.exports